import { useMediaDevices } from "@livekit/components-react";
import { useEffect, useState } from "react";

const useMediaPermissions = () => {
  const audioDevices = useMediaDevices({ kind: 'audioinput' });
  const videoDevices = useMediaDevices({ kind: 'videoinput' });

  const [isAllowedAudio, setIsAllowedAudio] = useState<boolean | undefined>();
  const [isAllowedVideo, setIsAllowedVideo] = useState<boolean | undefined>();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (audioDevices !== undefined && videoDevices !== undefined) {
      setIsAllowedAudio(audioDevices.length > 0);
      setIsAllowedVideo(videoDevices.length > 0);
      setIsLoading(false);
    }
  }, [audioDevices, videoDevices]);

  return {
    isAllowedAudio,
    isAllowedVideo,
    isLoading,
  };
};

export default useMediaPermissions;